/* eslint-disable import/prefer-default-export */

/**
 * Precalculate height only if the last refinement is overlapping the footer text.
 *
 * @param {JQuery} $bottom - bottom content
 * @param {number} lastRefinementEnd - position where the last refinement ends
 */
export const calculateBottomContentHeight = ($bottom, lastRefinementEnd) => {
    let downOffset = 0;
    const bottomStart = $bottom.offset().top;
    const alreadySetOffset = $bottom.attr('data-down-offset');
    const desktopMQ = window.matchMedia('(min-width: 1023px)');

    if (alreadySetOffset && alreadySetOffset !== '0') {
        downOffset = Number(alreadySetOffset);
    }
    if (lastRefinementEnd > bottomStart) {
        downOffset += lastRefinementEnd - bottomStart;
    } else if (downOffset) {
        downOffset -= bottomStart - lastRefinementEnd;
    }
    // don't pull up the bottom content more than the original position
    downOffset = Math.max(downOffset, 0);
    if (downOffset !== alreadySetOffset && desktopMQ.matches) {
        $bottom.attr('data-down-offset', downOffset);
        const transform = downOffset === 0 ? 'none' : `translate3d(0px, ${downOffset}px, 0px)`;
        $bottom.css('transform', transform);
    }
};
